import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { filterNonNull, guardArray } from "@msuite/utils/array";
import { guardString } from "@msuite/utils/strings";
import type { Enums, Nullable } from "@msuite/utils/types";
import { client } from "@/hono";

export function useAbsenceTypes(category: Nullable<Enums<"absenceCategory">>) {
	/** Query */
	const query = useQuery({
		queryKey: ["absence-types", guardString(category)],
		queryFn: async () => {
			if (!category) throw new Error();
			const response = await client.organizations.absences[":category"].types.$get({
				param: { category },
			});
			const data = await responseHandler(response);
			return data.absenceTypes.types;
		},
		enabled: !!category,
	});

	/** Computed */
	const absenceTypes = guardArray(query.data);
	const hasAbsenceTypes = filterNonNull(absenceTypes).length > 0;

	return { ...query, absenceTypes: guardArray(query.data), hasAbsenceTypes };
}
